import * as ValgTypes from '../Store/Valg/Types';

export function harValgtLandSomGirRekrutteringsstipendUtveksling(valg: ValgTypes.ValgState): boolean {
    if (valg.cLand?.id === "ZA" // Sør-Afrika
        ||
        valg.cLand?.id === "BR" // Brasil
        ||
        valg.cLand?.id === "JP" // Japan
        ||
        valg.cLand?.id === "IN" // India
        ||
        valg.cLand?.id === "CN" // Kina
        ||
        valg.cLand?.id === "KR") // Sør-Korea
        return true;
    return false;
}


